import { useState } from 'react'
import Typeahead from '../helpers/Typeahead'

export default function HeaderTypeahead() {
  const [focused, setFocus] = useState(0)

  return (
    <label
      className={`header-search desktop ${focused ? 'search-focused' : ''}`}
      onBlur={() =>
        setTimeout(function() {
          setFocus(false)
        }, 100)
      }
      onFocus={() => setFocus(true)}
    >
      <i className='search-icon font-icons find-icon' onClick={() => setFocus(true)} />
      <Typeahead />
      <i className='font-icons close-icon' />
    </label>
  )
}
